export default "__VITE_ASSET__BFq$GeD7__"